import { render, staticRenderFns } from "./SideRight.vue?vue&type=template&id=2c92c192&scoped=true"
import script from "./SideRight.vue?vue&type=script&lang=js"
export * from "./SideRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c92c192",
  null
  
)

export default component.exports